export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[640px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              追剧首选平台
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-3">
              天天影院 · 最新电视剧全集在线观看
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-heading mb-6">
              国产剧韩剧全集免费，美剧日剧播放不缓冲
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-[600px] mx-auto lg:mx-0">
              天天影院精心整理最新电视剧全集资源，覆盖国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源。每日同步更新，追剧无需等待。无论是最新热播大剧还是经典口碑佳片，全部剧集一网打尽，流畅播放不卡顿。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                每日更新 50+ 剧集
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                覆盖 12 个内容分类
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                高清流畅，无需缓冲
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-center"
              >
                开始追剧
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-background-100 text-foreground-800 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap text-center border border-background-200"
              >
                查看热播榜
                <i className="ri-fire-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3] lg:aspect-[16/10]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20atmosphere%20with%20floating%20film%20strips%20and%20soft%20golden%20light%2C%20elegant%20home%20theater%20setting%20with%20cozy%20ambient%20lighting%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20minimalist%20design%2C%20artistic%20composition%2C%20soft%20bokeh%20effect%2C%20premium%20entertainment%20mood%2C%20no%20text%20no%20logos&width=1200&height=750&seq=hero-cinema-main&orientation=landscape"
                alt="天天影院 · 沉浸式追剧体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/10 via-transparent to-transparent"></div>

              <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                <div className="flex-1 bg-background-50/90 backdrop-blur-sm rounded-lg px-4 py-3">
                  <p className="text-xs text-foreground-500 mb-1">正在热播</p>
                  <p className="text-sm font-semibold text-foreground-900 font-heading">今日更新剧集 12 部已上线</p>
                </div>
                <div className="bg-primary-500/90 backdrop-blur-sm rounded-lg px-4 py-3 flex items-center gap-2">
                  <span className="w-2 h-2 bg-background-50 rounded-full animate-pulse"></span>
                  <span className="text-xs text-background-50 font-medium whitespace-nowrap">正在更新</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}